import { render } from "./FullScreen.vue?vue&type=template&id=f5bdfc76"
import script from "./FullScreen.vue?vue&type=script&lang=js"
export * from "./FullScreen.vue?vue&type=script&lang=js"
script.render = render

export default script